<div class="search-link__content" (click)="$event.stopPropagation()">
    <div class="search-link__input">
        <input class="search-link__input"
               [placeholder]="placeholder" type="text"
               (input)="onSearch(search.value)"
               #search
        >
        <img class="search-link__input-icon"
             src="assets/svg/ic-search.svg"
             alt="search-icon"
             (click)="search.focus()"
        >
    </div>
    <ul class="search-link__results">
        @if (!isLoading) {
            @if (dataSearch.length) {
                @for (item of getFilteredBySearch(dataSearch, search.value); track item) {
                    <li class="search-link__result">
                        <a [routerLink]="item.link">{{ item.name }}</a>
                    </li>
                }
            } @else {
                <li>{{ 'SEARCH_LINK.SEARCH_RESULT_EMPTY' | translate }}</li>
            }
        } @else {
            <li>{{ loadingPlaceholder | translate }}</li>
        }
    </ul>
</div>
